import { ColumnDef } from '@tanstack/react-table'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import { APPLICATION_SETTINGS } from '../../../../common/constants'
import { propertyResponseFields } from '../../../../common/response/property'
import { formatNumberWithTwoDecimals } from '../../../../utils/general'
import { renderCurrency } from '../../../../utils/property'
import { ConnectedPropertyRow } from './utils'

const useTableColumns = () => {
    const currency = APPLICATION_SETTINGS.CURRENCY

    const { t } = useTranslation()

    const columns = useMemo(
        (): ColumnDef<ConnectedPropertyRow>[] => [
            {
                id: propertyResponseFields.INTERNAL_APP_ID,
                header: t('app.common.id'),
                accessorKey: propertyResponseFields.INTERNAL_APP_ID,
                enableSorting: false,
            },
            {
                id: 'status',
                header: t('app.common.status'),
                accessorFn: (row) => row.status?.name,
                enableSorting: false,
            },
            {
                id: 'type',
                header: t('app.common.type'),
                accessorFn: (row) => (typeof row.type === 'string' ? row.type : row.type?.name),
                enableSorting: false,
            },
            {
                id: 'date',
                header: t('app.common.date'),
                accessorKey: 'date',
                enableSorting: false,
            },
            {
                id: 'city',
                header: t('app.common.city'),
                accessorKey: 'city',
                enableSorting: false,
            },
            {
                id: 'street',
                header: t('app.common.street'),
                accessorKey: 'street',
                enableSorting: false,
                size: 200,
            },
            {
                id: 'price',
                header: t('app.common.price', { currency: renderCurrency(currency) }),
                cell: ({ row }) => {
                    const formattedPrice = row.original?.price && formatNumberWithTwoDecimals(Number(row.original?.price))
                    return <>{formattedPrice}</>
                },
                enableSorting: false,
                size: 120,
            },
            {
                id: 'actions',
                cell: ({ row }) => {
                    const id = row.original?.id

                    return (
                        <ul className="list-inline hstack gap-2 mb-0 justify-content-center">
                            <li className="list-inline-item">
                                <Link title={t('button.view')} to={`/properties/${id}`} className="btn d-inline-block p-0 text-info">
                                    <i className="mdi mdi-eye-outline fs-16"></i>
                                </Link>
                            </li>
                        </ul>
                    )
                },
                meta: { tdClass: 'text-center' },
            },
        ],
        [currency, t]
    )

    return columns
}

export default useTableColumns
